


function Reconciliation() {
  
  return (
    <>
      <header className="page-title-bar">
        <h1 className="page-title mr-sm-auto mb-0"> Reconciliation </h1>
      </header>
      

      <div className="card d-none">
        <div className="card-body">
          
        </div>
      </div>
    </>
  );
}

export default Reconciliation;
